// TODO: Refactor code in that old file
// use regex only internally, provide API to prase / replace using parsing results
// add types for all groups

import { EMAIL_DYNAMIC_VARIABLE_REGEX } from "@mapmycustomers/shared/util/email/parseEmailDynamicVariables";

const URL_REGEX =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/g;

const EMAIL_REGEX = /\S+@\S+\.\S+/g;

const PHONE_REGEX = /(\+?\d{1,2}[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g;

export const EMAIL_TEXT_REGEX = new RegExp(
  `(?<url>${URL_REGEX.source})|(?<email>${EMAIL_REGEX.source})|(?<phone>${PHONE_REGEX.source})|(?<dynamic_var>${EMAIL_DYNAMIC_VARIABLE_REGEX.source})`,
  "g"
);

const parseEmailText = (text: string) => {
  return Array.from(text.matchAll(EMAIL_TEXT_REGEX)).map((match) => ({
    index: match.index,
    length: match[0].length,
    text: match[0],
    type: Object.keys(match.groups!).find((k) => !!match.groups![k]),
  }));
};

export default parseEmailText;
